const initialState = {
  states: [],
  districts: [],
  centers: [],
  errorMsg: "",
};

export default initialState;
